import { SkillCategory } from '../types';

export const skills: SkillCategory[] = [
  {
    category: "Backend Development",
    items: [
      "Laravel PHP",
      "RESTful APIs",
      "Filament",
      "MySQL & PostgreSQL",
      "Redis",
      "PHPUnit/Pest",
    ],
    icon: "Database",
  },
  {
    category: "Mobile Development",
    items: [
      "Flutter & Dart",
      "Clean Architecture",
      "State Management",
      "SQLite & Hive",
      "iOS & Android Deployment",
      "Cross-platform",
    ],
    icon: "Smartphone",
  },
  {
    category: "Real-Time & Services",
    items: [
      "WebSockets",
      "Socket.IO",
      "Pusher",
      "Firebase & FCM",
      "OneSignal",
      "Google Maps",
    ],
    icon: "Code",
  },
  {
    category: "DevOps & Infrastructure",
    items: [
      "Docker",
      "Nginx",
      "CI/CD",
      "Git",
      "Jira",
      "Deployment",
    ],
    icon: "GitBranch",
  },
  {
    category: "Integrations & Security",
    items: [
      "API Integration",
      "Stripe & PayPal",
      "RBAC & Access Control",
      "Microservices",
      "WebSocket APIs",
      "Payment Gateways",
    ],
    icon: "Database",
  },
  {
    category: "Engineering Practices",
    items: [
      "Clean Code",
      "OOP & SOLID",
      "MVC Architecture",
      "Testing & Debugging",
      "Problem Solving",
      "Code Review",
    ],
    icon: "TestTube",
  },
];
